<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs
          v-model="$route.params.device_group_id"
          @click_breadCrumbs="selectedGroupChange"
          lastItemDisabled
        />
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="compressorGroup in compressorGroups" :key="compressorGroup.id" cols="12">
        <v-toolbar v-if="compressorGroup.compressors.length > 0" dense flat>
          <v-icon v-if="compressorGroup.id === 'all'" color="primary" class="pb-1 mr-3"> mdi-factory </v-icon>
          <v-toolbar-title>
            {{ compressorGroup.name }}：{{ compressorGroup.compressors.length }} {{ $t('machines') }}
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                @click="openPage"
                class="mr-2"
                icon
                v-if="user_info.admin && compressorGroup.id === 'all'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-email</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('alarmNotificationEmailSettings') }}</span>
          </v-tooltip>
          <!-- 消費電力・吐出空気量グラフ -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'VolumeGraph',
                  params: {
                    device_group_id: $route.params.device_group_id,
                    group_id: compressorGroup.id,
                    compressors: compressorGroup.compressors,
                  },
                }"
                color="primary"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <custom-icon type="powerConsumption" :size="25" :colors="['#162A4F']"> </custom-icon>
              </v-btn>
            </template>
            <span>{{ $t('dischargeAirVolumePowerConsumptionGraph') }}</span>
          </v-tooltip>

          <!-- 月報 -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$route.params.device_group_id"
                :to="{
                  name: 'MonthlyReport',
                  params: {
                    device_group_id: $route.params.device_group_id,
                    group_id: compressorGroup.id,
                    compressors: compressorGroup.compressors,
                  },
                }"
                color="primary"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon>mdi-file-document-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('monthlyReport') }}</span>
          </v-tooltip>

          <!-- アラーム履歴 -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'AlermHistory',
                  params: {
                    device_group_id: $route.params.device_group_id,
                    group_id: compressorGroup.id,
                    compressors: compressorGroup.compressors,
                  },
                }"
                color="primary"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon>mdi-alert-circle</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('alarmRecords') }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-divider></v-divider>
        <v-row class="mt-3" v-if="compressorGroup.id !== 'all'">
          <v-col
            v-for="compressor in compressorGroup.compressors"
            :key="compressor.serialNo"
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-card
              :to="{
                name: 'CompressorInfo',
                params: {
                  model_id: compressor.modelId,
                  serial_no: compressor.serialNo,
                },
                query: {
                  locale: $i18n.locale,
                },
              }"
              target="_blank"
              outlined
              hover
              height="300"
              :loading="compressor.loading"
              :style="{
                border: `10px solid ${panelColor(compressor)}`,
              }"
            >
              <v-card-text class="card-text">
                <v-row justify="end">
                  <v-col v-if="compressor.communication" cols="5">
                    <v-row dense>
                      <v-col cols="4" class="connection-area">
                        <v-icon large v-text="compressor.connection ? 'mdi-signal' : 'mdi-signal-off'"> </v-icon>
                      </v-col>
                      <v-col cols="4" class="maintenance-notification-area">
                        <v-icon
                          v-if="['danger', 'warning', 'notice'].includes(compressor.maintenanceNotificationStatus)"
                          class="material-symbols-outlined"
                          large
                          v-text="maintenanceNotificationIcon(compressor)"
                          :color="maintenanceNotificationColor(compressor)"
                        >
                        </v-icon>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="12" class="text-center alarm-area">
                        <v-row v-show="blinkStart" dense align="center" justify="center">
                          <v-col v-if="compressor.emergency" cols="4">
                            <v-img src="@/assets/emergency.png" height="48" contain class="blinking"> </v-img>
                          </v-col>
                          <v-col v-if="compressor.caution" cols="4">
                            <v-img src="@/assets/caution.png" height="48" contain class="blinking"> </v-img>
                          </v-col>
                          <v-col v-if="compressor.maintenance" cols="4">
                            <v-img src="@/assets/maintenance.png" height="48" contain class="blinking"> </v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="cog-area text-center">
                        <v-img :src="cogStatusImgPath(compressor)" height="40" contain> </v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="7" align-self="center">
                    <v-img
                      :src="compressorImgPath(compressor.type)"
                      height="120"
                      width="100%"
                      contain
                      :style="{
                        opacity: compressor.communication ? 1 : 0.5,
                      }"
                    >
                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row class="compressor-info text-center font-weight-bold" dense>
                  <v-col cols="12">{{ compressor.customerManagementUnit }}</v-col>
                  <v-col cols="12">{{ compressor.machineUnit }}</v-col>
                  <v-col cols="12">{{ compressor.model }}</v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomIcon from '../components/CustomIcon.vue';
  import modelMapping from '../resources/model_mapping.json';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import { mapGetters } from 'vuex';
  import '@/assets/css/consumer.css';
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'HomeConsumer',
    components: {
      CustomIcon,
      BreadCrumbs,
    },
    data: () => ({
      compressorGroups: [],
      intervalId: '',
      intervalTime: 60000,
      blinkStart: false,
    }),
    computed: {
      ...mapGetters('auth', ['user_info']),
      // 各パネルのカラーコードを返す
      panelColor() {
        return (value) => {
          if (value.connection) {
            if (value.emergency) {
              // 赤
              return '#EF5350';
            } else if (value.caution) {
              // オレンジ
              return '#FF9800';
            } else if (value.maintenance) {
              // 黄
              return '#FDD835';
            } else {
              // 緑or黒
              return value.start ? '#8BC34A' : '#212121';
            }
          } else {
            // 灰
            return '#9E9E9E';
          }
        };
      },
      // コンプレッサーの画像のパスを返す
      compressorImgPath() {
        return (value) => {
          return value === 'OIL_INJECTION' ? require('@/assets/oil_injection.png') : require('@/assets/oil_free.png');
        };
      },
      // 歯車の画像パスを返す
      cogStatusImgPath() {
        return (value) => {
          return value.start && value.connection ? require('@/assets/cog_run.gif') : require('@/assets/cog_stop.jpg');
        };
      },
      // メンテナンス通知のアイコンを返す
      maintenanceNotificationIcon() {
        return (value) => {
          const icons = {
            danger: 'clock_loader_90',
            warning: 'clock_loader_60',
            notice: 'clock_loader_10',
          };
          return icons[value.maintenanceNotificationStatus] || '';
        };
      },
      // メンテナンス通知の色を返す
      maintenanceNotificationColor() {
        return (value) => {
          const colors = {
            danger: '#FF0000', // 赤
            warning: '#FFA500', // オレンジ
            notice: '#00FF26', // 緑
          };
          return colors[value.maintenanceNotificationStatus] || '';
        };
      },
    },
    async created() {
      this.$store.commit('loading/start_loading');
      // 全件表示グループ
      const allGroup = {
        id: 'all',
        name: '',
        devices: [],
        compressors: [],
      };
      // グループ未設定のグループ
      const unsetGroup = {
        id: 'unset',
        name: this.$t('groupNotSet'),
        devices: [],
        compressors: [],
      };
      const userDeviceAuthorities = await this.getUserDeviceAuthorities(this.$route.params.device_group_id);
      if (userDeviceAuthorities) {
        // 全件表示用に工場名を設定
        allGroup.name = userDeviceAuthorities[0].device_group_name_locale1;
        // 全件表示グループはトップに表示する
        this.compressorGroups.push(allGroup);
        // 普遍的な需要家コードをserialNoから取得
        const consumerId = `${userDeviceAuthorities[0].serial_no.replace(/^.*_/, '')}$`;
        // 需要家が設定したグループを取得して配列に格納
        const deviceGroups = await this.getGroups(consumerId);
        if (deviceGroups) {
          for (const deviceGroup of deviceGroups) {
            if (deviceGroup.devices.length > 0) {
              const compressorGroup = {
                id: deviceGroup.id,
                name: deviceGroup.groupName,
                devices: deviceGroup.devices,
                compressors: [],
              };
              this.compressorGroups.push(compressorGroup);
            }
          }
        }
        // ユーザーに紐づくメンテナンス通知情報を取得
        const userId = this.user_info.userId;
        const maintenanceNotifications = await this.getMaintenanceNotifications(userId);

        // 各コンプレッサーの設定
        for (const userDeviceAuthoritie of userDeviceAuthorities) {
          const latestSensorData = await this.getLatestSensorDatas(
            userDeviceAuthoritie.model_id,
            userDeviceAuthoritie.serial_no
          );
          const compressor = {
            customerManagementUnit: userDeviceAuthoritie.optional_info_2, // お客様管理号機
            model: userDeviceAuthoritie.optional_info_1, // 型式
            machineUnit: userDeviceAuthoritie.serial_no.replace(/_.*$/, ''), // 機械号機
            serialNo: userDeviceAuthoritie.serial_no,
            modelId: userDeviceAuthoritie.model_id,
            type: modelMapping[userDeviceAuthoritie.model_id].type,
            loading: false,
            start: false, // 稼働
            emergency: false, // エラー
            caution: false, // 警告
            maintenance: false, // メンテナンス
            connection: true, // 通信
            communication: true, // 疎通
          };
          this.setSensorData(compressor, latestSensorData);
          this.setMaintenanceNotificationStatus(compressor, maintenanceNotifications);
          // グループ未設定フラグ
          let groupConfigured = false;
          for (const compressorGroup of this.compressorGroups) {
            if (compressorGroup.id === 'all') {
              compressorGroup.compressors.push(compressor);
            }
            for (const device of compressorGroup.devices) {
              if (device.serialNo === compressor.serialNo && device.modelId === compressor.modelId) {
                // devices配列内のserialNoとmodelIdに合致すればそのグループのコンプレッサーに設定
                compressorGroup.compressors.push(compressor);
                // 1つでも一致するグループがあればグループ設定済みとする
                groupConfigured = true;
              }
            }
          }
          if (!groupConfigured) {
            // どのグループにも所属しない場合は、グループ未設定グループのコンプレッサーに設定
            unsetGroup.compressors.push(compressor);
          }
        }
        // グループ未設定グループは一番末尾に追加する
        this.compressorGroups.push(unsetGroup);
        // センサーデータを一分毎に更新する設定
        this.setSensorDataInterval();
      }
      // 点滅アイコンの開始タイミングを揃える
      this.blinkStart = true;
      this.$store.commit('loading/end_loading');
    },
    methods: {
      async getUserDeviceAuthorities(deviceGroupId) {
        const userDeviceAuthorities = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
          device_group_id: deviceGroupId,
          sort: 'optional_info_2,serial_no',
        });
        return userDeviceAuthorities;
      },
      async getLatestSensorDatas(modelId, serialNo) {
        const latestSensorDatas = await this.apiRequest('/v1/sensor-data-file-mgt/getLatestSensorData', 'POST', {
          sensor_list: [
            {
              model_id: modelId,
              serial_no: serialNo,
            },
          ],
        });
        return latestSensorDatas[0];
      },
      async getGroups(deviceGroupId) {
        const param = {
          deviceGroupId: deviceGroupId,
        };
        const groups = await this.azureRequest('/api/getGroups', 'GET', param);
        return groups;
      },
      async getMaintenanceNotifications(userId) {
        const maintenanceNotifications = await this.azureRequest('/api/getMaintenanceNotifications', 'GET', {
          userId: userId,
        });
        return maintenanceNotifications;
      },
      async openPage() {
        this.$store.commit('loading/start_loading');
        const userDeviceAuthorities = await this.getUserDeviceAuthorities(this.$route.params.device_group_id);
        console.log(userDeviceAuthorities);
        try {
          this.$router.push({
            name: 'AlermMailSetting',
            params: {
              device_group_id: this.user_info.deviceGroupId,
              group_id: userDeviceAuthorities[0].device_group_id,
              device_group_name_locale: userDeviceAuthorities[0].device_group_name_locale1,
            },
          });
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      setSensorData(compressor, latestSensorData) {
        // LED ランプ状態(Hex)のオブジェクトのみ抽出
        const panelLamp = latestSensorData.timeList.filter((item) => item.sensorId === 'sn_D027');
        // センサーのデータリスト配列が空の場合未疎通とみなす
        if (panelLamp[0].dataList.length > 0) {
          const fromDate = this.getMomentObj(panelLamp[0].dataList[0].measureTime);
          const toDate = this.$moment.utc();
          const diffDate = toDate.diff(fromDate, 'minutes');
          // 10進数を2進数に変換し、1桁ずつ配列に分け配列を逆順にする
          const lampDatas = Number(panelLamp[0].dataList[0].data).toString(2).match(/.{1}/g).reverse();
          // Power、Emergency、AutoStart、Caution、Load、Maintenance、Local、Stop、Start
          // Startフラグ
          compressor.start = Boolean(lampDatas[modelMapping[compressor.modelId].start] === '1');
          // Emergencyフラグ
          compressor.emergency = Boolean(lampDatas[modelMapping[compressor.modelId].emergency] === '1');
          // Cautionフラグ
          compressor.caution = Boolean(lampDatas[modelMapping[compressor.modelId].caution] === '1');
          // Maintenanceフラグ
          compressor.maintenance = Boolean(lampDatas[modelMapping[compressor.modelId].maintenance] === '1');
          // 未疎通フラグ
          compressor.communication = true;
          // 最新のデータ取得時刻が現在の時刻と比べて160分以上前であれば「通信断」と判定
          compressor.connection = Boolean(diffDate < 160);
        } else {
          compressor.start = false;
          compressor.emergency = false;
          compressor.caution = false;
          compressor.maintenance = false;
          compressor.communication = false;
          compressor.connection = false;
        }
      },
      setMaintenanceNotificationStatus(compressor, maintenanceNotifications) {
        compressor.maintenanceNotificationStatus = null;

        if (maintenanceNotifications) {
          const maintenanceNotification = maintenanceNotifications.find(
            (item) => item.equipmentNo === compressor.machineUnit
          );

          if (maintenanceNotification) {
            compressor.maintenanceNotificationStatus = maintenanceNotification.status;
          }
        }
      },
      // measureTimeをmomentオブジェクトに変換
      getMomentObj(value) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const date = value.substring(6, 8);
        const hour = value.substring(8, 10);
        const min = value.substring(10, 12);
        const sec = value.substring(12, 14);
        // const msec = value.substring(14, 20)
        return this.$moment.utc(`${year}-${month}-${date} ${hour}:${min}:${sec}`);
      },
      setSensorDataInterval() {
        this.intervalId = setInterval(async () => {
          for (const compressorGroup of this.compressorGroups) {
            for (const compressor of compressorGroup.compressors) {
              compressor.loading = true;
              const latestSensorData = await this.getLatestSensorDatas(compressor.modelId, compressor.serialNo);
              this.setSensorData(compressor, latestSensorData);
              compressor.loading = false;
            }
          }
        }, this.intervalTime);
      },
      selectedGroupChange(group) {
        if (group.children.length > 0) {
          this.$router.push({
            name: 'HomeAdmin',
            params: {
              device_group_id: group.device_group_id,
            },
          });
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
  };
</script>
<style scoped></style>
